/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_ReferenceInputs */

const en_nav_reference = /** @type {(inputs: Nav_ReferenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reference data`)
};

/**
* | output |
* | --- |
* | "Reference data" |
*
* @param {Nav_ReferenceInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_reference = /** @type {((inputs?: Nav_ReferenceInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_ReferenceInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_reference(inputs)
});